module.exports = __webpack_public_path__ + "img/icon-25.fc2574b3.png";